/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface ServiceTypeOrgCount { 
    /**
     * Orgs belonging to this service type
     */
    count?: number;
    service_type?: ServiceTypeEnum;
}
export namespace ServiceTypeOrgCount {
}


